import { Repository } from "./adapters/repository";

import * as retrieveProjectTimeSheet from "./useCases/retrieveProjectTimeSheet";
import * as saveTimeRecord from "./useCases/saveTimeRecord";
import * as validateTimeRecordsUpToDate from "./useCases/validateTimeRecordsUpToDate";
import * as retrievePersonalTimeSheet from "./useCases/retrievePersonalTimeSheet";
import * as validatePersonalTimeRecordsUpToDate from "./useCases/validatePersonalTimeRecordsUpToDate";
import * as reloadTimeSheet from "./useCases/reloadTimeSheet";
import * as reloadProjectTimeSheet from "./useCases/reloadProjectTimeSheet";
import * as retrieveTimeSheet from "./useCases/retrieveTimeSheet";
import * as retrieveWeekTimeRecords from "./useCases/retrieveWeekTimeRecords";
import * as deleteTimeRecord from "./useCases/deleteTimeRecord";

enum UseCases {
  retrieveProjectTimeSheet = "retrieveProjectTimeSheet",
  saveTimeRecord = "saveTimeRecord",
  validateTimeRecordsUpToDate = "validateTimeRecordsUpToDate",
  retrievePersonalTimeSheet = "retrievePersonalTimeSheet",
  validatePersonalTimeRecordsUpToDate = "validatePersonalTimeRecordsUpToDate",
  reloadTimeSheet = "reloadTimeSheet",
  reloadProjectTimeSheet = "reloadProjectTimeSheet",
  retrieveTimeSheet = "retrieveTimeSheet",
  retrieveWeekTimeRecords = "retrieveWeekTimeRecords",
  deleteTimeRecord = "deleteTimeRecord",
}

interface Core {
  [UseCases.retrieveProjectTimeSheet]: retrieveProjectTimeSheet.Interactor;
  [UseCases.saveTimeRecord]: saveTimeRecord.Interactor;
  [UseCases.validateTimeRecordsUpToDate]: validateTimeRecordsUpToDate.Interactor;
  [UseCases.retrievePersonalTimeSheet]: retrievePersonalTimeSheet.Interactor;
  [UseCases.validatePersonalTimeRecordsUpToDate]: validatePersonalTimeRecordsUpToDate.Interactor;
  [UseCases.reloadTimeSheet]: reloadTimeSheet.Interactor;
  [UseCases.reloadProjectTimeSheet]: reloadProjectTimeSheet.Interactor;
  [UseCases.retrieveTimeSheet]: retrieveTimeSheet.Interactor;
  [UseCases.retrieveWeekTimeRecords]: retrieveWeekTimeRecords.Interactor;
  [UseCases.deleteTimeRecord]: deleteTimeRecord.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveProjectTimeSheet]:
      retrieveProjectTimeSheet.createInteractor(dependencies.repository),
    [UseCases.saveTimeRecord]: saveTimeRecord.createInteractor(
      dependencies.repository,
    ),
    [UseCases.validateTimeRecordsUpToDate]:
      validateTimeRecordsUpToDate.createInteractor(dependencies.repository),
    [UseCases.retrievePersonalTimeSheet]:
      retrievePersonalTimeSheet.createInteractor(dependencies.repository),
    [UseCases.validatePersonalTimeRecordsUpToDate]:
      validatePersonalTimeRecordsUpToDate.createInteractor(
        dependencies.repository,
      ),
    [UseCases.reloadTimeSheet]: reloadTimeSheet.createInteractor(
      dependencies.repository,
    ),
    [UseCases.reloadProjectTimeSheet]: reloadProjectTimeSheet.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveTimeSheet]: retrieveTimeSheet.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveWeekTimeRecords]:
      retrieveWeekTimeRecords.createInteractor(dependencies.repository),
    [UseCases.deleteTimeRecord]: deleteTimeRecord.createInteractor(
      dependencies.repository,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
